/**
 * ServiceBlock
 */
import React from 'react';
import { Icon } from 'ui-component-library/base';
import { Link as LinkBase } from 'ui-component-library/base';
import '../../web-components/block-link.js';
/** Main description for this component. */
var ServiceBlock = function (_a) {
    var heading = _a.heading, text = _a.text, url = _a.url, icon = _a.icon, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c;
    var Heading = headingLevel;
    var Link = LinkComponent;
    return (React.createElement("block-link", { class: "service-block flex justify-between align-top rounded p-4", "data-cid": "ServiceBlock" },
        React.createElement("div", { className: "flex" },
            icon && (React.createElement("span", { className: "mr-3" },
                React.createElement(Icon, { icon: icon, size: 1.25, color: "#00636A", "aria-hidden": true }))),
            React.createElement("div", { className: "-mt-0.5" },
                React.createElement(Link, { to: url, className: "group block", "data-cid": "ServiceBlock" },
                    React.createElement(Heading, { className: "text-h3 font-normal text-teal group-hover:underline" }, heading)),
                text && React.createElement("p", { className: "text-p text-greyDarker" }, text))),
        React.createElement("span", null,
            React.createElement(Icon, { icon: "chevron", direction: "left", color: "#00636A", "aria-hidden": true }))));
};
export default ServiceBlock;
